import { render, staticRenderFns } from "./GenreList.vue?vue&type=template&id=7d915292&"
import script from "./GenreList.vue?vue&type=script&lang=ts&"
export * from "./GenreList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports